/**
 * Growth Route Constants
 * Contains objective activity status formats and parent type names
 */

/**
 * Parent type name for behavior objectives
 */
export const PARENT_TYPE_BEHAVIOR = 'behavior';

/**
 * Alternative status formats that may come from the backend
 * These are used for backward compatibility and status normalization
 */
export const STATUS_NOT_STARTED_UNDERSCORE = 'not_started';
export const STATUS_IN_PROGRESS_UNDERSCORE = 'in_progress';
export const STATUS_COMPLETED_SPANISH = 'completado';
export const STATUS_FINALIZED_SPANISH = 'finalizado';
export const STATUS_COMPLETED_ENGLISH = 'completed';

/**
 * Priority levels for objectives
 */
export const PRIORITY_HIGH = 'alta';
export const PRIORITY_MEDIUM = 'media';
export const PRIORITY_LOW = 'baja';

/**
 * Priority IDs for backend mapping
 */
export const PRIORITY_HIGH_ID = 3;
export const PRIORITY_MEDIUM_ID = 2;
export const PRIORITY_LOW_ID = 1;

/**
 * View modes
 */
export const VIEW_MODE_GRID = 'grid';
export const VIEW_MODE_LIST = 'list';

/**
 * Step identifiers
 */
export const STEP_START = 'start';
export const STEP_1 = '1';
export const STEP_2 = '2';
export const STEP_3 = '3';
export const STEP_END = 'end';

/**
 * Empty priority value
 */
export const EMPTY_PRIORITY = '';

/**
 * Step titles and descriptions
 */
export const STEP_START_TITLE = 'Comienza tu ruta de crecimiento';
export const STEP_HIGH_PRIORITY_TITLE = 'Prioridad alta:';
export const STEP_HIGH_PRIORITY_DESCRIPTION = '¡Empieza por los temas más importantes!';
export const STEP_MEDIUM_PRIORITY_TITLE = 'Prioridad media:';
export const STEP_MEDIUM_PRIORITY_DESCRIPTION = 'Avanza con los temas de seguimiento';
export const STEP_LOW_PRIORITY_TITLE = 'Prioridad baja:';
export const STEP_LOW_PRIORITY_DESCRIPTION = 'Avanza con los temas de seguimiento';
export const STEP_END_TITLE = '¡Has completado tu ruta!';
export const STEP_END_DESCRIPTION = 'Prepárate para los próximos desafíos';

/**
 * Warning messages
 */
export const WARNING_NO_PRIORITY_STEP = 'No se puede mover objetivos a un paso sin prioridad.';

/**
 * Empty objectives placeholder count
 */
export const EMPTY_OBJECTIVES_COUNT = 3;

/**
 * Priority dropdown options for Roadmap cart mode
 */
export const PRIORITY_DROPDOWN_OPTIONS = [
  { label: 'Alta', value: PRIORITY_HIGH_ID },
  { label: 'Media', value: PRIORITY_MEDIUM_ID },
  { label: 'Baja', value: PRIORITY_LOW_ID },
];

/**
 * Objective status - closed state
 */
export const OBJECTIVE_STATUS_COMPLETED = 'completado';

/**
 * Goal progress status IDs (from goal_progress_status table)
 */
export const PROGRESS_STATUS_PENDING_ID = 1;
export const PROGRESS_STATUS_IN_PROGRESS_ID = 2;
export const PROGRESS_STATUS_COMPLETED_ID = 3;

/**
 * Objective tabs
 */
export const OBJECTIVE_TAB_ACTIVE = 'Objetivos Pendientes';
export const OBJECTIVE_TAB_CLOSED = 'Objetivos Completados';
export const OBJECTIVE_TAB_ARCHIVED = 'Objetivos Archivados';

/**
 * Archived objectives (HU 12.4): status, backend error code and UI texts
 */
export const PROGRESS_STATUS_ARCHIVED_ID = 4;
export const GOAL_ARCHIVED_ERROR_CODE = 'GOAL_ARCHIVED';
export const ARCHIVED_STEP_TITLE = 'Objetivos Archivados:';
export const ARCHIVED_STEP_DESCRIPTION =
  'Estos objetivos salieron de tu mapa de crecimiento vigente y no suman a tu progreso actual';
export const ARCHIVED_EMPTY_MESSAGE = 'No tienes objetivos archivados.';
export const ARCHIVED_BADGE_LABEL = 'Archivado';
export const ARCHIVED_MAP_PREFIX = 'Mapa archivado:';
export const ARCHIVED_MAP_UNAVAILABLE = 'Mapa no disponible';
export const ARCHIVED_DATE_PREFIX = 'Archivado el';
